/* eslint-disable id-length */
import { traffic2 } from '../../utils/buildAnalyticsEvents';

export const PLAN_EVENTS = {
  PLANS_IMPRESSION: {
    ...traffic2('marketing.plans.impression')
  },
  PREMIER_IMPRESSION: {
    ...traffic2('marketing.premier.impression')
  },
  START_FOR_FREE_PREMIER_CLICK: {
    ...traffic2('marketing.plans.start_for_free.button.click')
  },
  START_FOR_FREE_ESSENTIALS_CLICK: {
    ...traffic2('marketing.plans.essentials.button.click')
  },
  START_FOR_FREE_DELUXE_CLICK: {
    ...traffic2('marketing.plans.deluxe.button.click')
  },
  START_FOR_FREE_ULTIMATE_CLICK: {
    ...traffic2('marketing.plans.ultimate.button.click')
  },
  START_FOR_FREE_PREMIER_PLAN_CLICK: {
    ...traffic2('marketing.plans.premier.button.click')
  }
};
